import('./bootstrap');

/* Following: https://code.amazon.com/reviews/CR-158271723/revisions/2#/details
 * We now put the whole (old) index.tsx into an async context, to fix the bug "Shared module is not available for eager consumption"
 * that's caused by Federation one. It will try to load the component even before main page is loaded on standalone pages.
 */
